import { Trans } from "../utils/i18n";
import Cookies from "js-cookie";
import React from "react";
import {validateVinRegEx} from "../Shared/FormField";

export const queueDetailConfigTa72 = {
    "sizes": {
        "forth": 3,
        "third": 4,
        "half": 6,
        "full": 12
    },
    "heading": <Trans i18nKey="orderEntry.basicData">Basic data</Trans>,
    "groups": [
        {
            "heading": <Trans i18nKey="queueDetail.appointment.label">Appointment</Trans>,
            "fields": [
                {
                    "name": "appointment_date",
                    "label": <Trans i18nKey="queueDetail.appointment.label">Appointment</Trans>,
                    "size": "full",
                    "type": "datetimepicker",
                },
            ],
        },
        // {
        //     "heading": <Trans i18nKey="queueDetail.partner">Partner</Trans>,
        //     "fields": [
        //         {
        //             "name": "partner_id",
        //             "size": "full",
        //             "type": 'partnerselect'
        //         },
        //     ]
        // },
        {
            "heading": <Trans i18nKey="queueDetail.oldHardware.heading">Old hardware</Trans>,
            "fields": [
                {
                    "name": "serialnumber",
                    "label": <Trans i18nKey="queues.serialNumber">Serial number</Trans>,
                    "size": "full",
                },
            ]
        },
        {
            "heading": <Trans i18nKey="queueDetail.newHardware.heading">New hardware</Trans>,
            "fields": [
                {
                    "name": "outgoingProductId",
                    "label": <Trans i18nKey="queues.product">Product</Trans>,
                    "size": "full",
                    // "required": true,
                    "type": "productdropdown",
                },
                {
                    "name": "outgoingSerialnumber",
                    "label": <Trans i18nKey="queues.serialNumber">Serial number</Trans>,
                    "size": "full",
                },
            ]
        },
        {
            "heading": <Trans i18nKey="queueDetail.configurations.label">Configurations</Trans>,
            "fields": [
                {
                    "size": "full",
                    "key": "configurations",
                    "name": "configurations",
                    "label": <Trans i18nKey="queueDetail.configurations.label">Configurations</Trans>,
                    "required": true,
                    "type": "metapicker"
                },
            ]
        },
        {
            "heading": <Trans i18nKey="queueDetail.serviceTimes.label">Service times</Trans>,
            "fields": [
                {
                    "name": "start_datetime",
                    "label": <Trans i18nKey="queueDetail.serviceStart.label">Service start</Trans>,
                    "size": "full",
                    "type": "datetimepicker",
                    "allowPast": true,
                },
                {
                    "name": "end_datetime",
                    "label": <Trans i18nKey="queueDetail.serviceEnd.label">Service end</Trans>,
                    "size": "full",
                    "type": "datetimepicker",
                    "allowPast": true,
                },
            ],
        },
        {
            "heading": <Trans i18nKey="queueDetail.installationReport.heading">Installation report</Trans>,
            "fields": [
                {
                    "name": "",
                    "size": "full",
                    "component": 'queuedetaildropzone',
                    "enableType": false,
                },
            ]
        },
        {
            "heading": <Trans i18nKey="queueDetail.status.heading">Status</Trans>,
            "fields": [
                {
                    "name": "status_id",
                    "size": "full",
                    "type": 'statusselect'
                },
            ]
        },
    ],
}
